/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ComIbmCommerceContractBeansExtendedTermConditionDataBeanIBMStoreDetails } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ComIbmCommerceToolsContractBeansDisplayCustomizationTCDataBeanIBMStoreDetails } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * TermConditionApi - axios parameter creator
 * @export
 */
export const TermConditionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Finds the display customization TC of the account associated with the current user.
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdTermConditionGet: async (storeId: string, q: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeStoreIdTermConditionGet', 'storeId', storeId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('storeStoreIdTermConditionGet', 'q', q)
            const localVarPath = `/store/{storeId}/term_condition`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds a term condition by its ID.
         * @param {string} storeId The store identifier.
         * @param {string} termConditionId The term condition ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdTermConditionTermConditionIdGet: async (storeId: string, termConditionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeStoreIdTermConditionTermConditionIdGet', 'storeId', storeId)
            // verify required parameter 'termConditionId' is not null or undefined
            assertParamExists('storeStoreIdTermConditionTermConditionIdGet', 'termConditionId', termConditionId)
            const localVarPath = `/store/{storeId}/term_condition/{termConditionId}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"termConditionId"}}`, String(termConditionId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermConditionApi - functional programming interface
 * @export
 */
export const TermConditionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermConditionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Finds the display customization TC of the account associated with the current user.
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeStoreIdTermConditionGet(storeId: string, q: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComIbmCommerceToolsContractBeansDisplayCustomizationTCDataBeanIBMStoreDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeStoreIdTermConditionGet(storeId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Finds a term condition by its ID.
         * @param {string} storeId The store identifier.
         * @param {string} termConditionId The term condition ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeStoreIdTermConditionTermConditionIdGet(storeId: string, termConditionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComIbmCommerceContractBeansExtendedTermConditionDataBeanIBMStoreDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeStoreIdTermConditionTermConditionIdGet(storeId, termConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermConditionApi - factory interface
 * @export
 */
export const TermConditionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermConditionApiFp(configuration)
    return {
        /**
         * 
         * @summary Finds the display customization TC of the account associated with the current user.
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdTermConditionGet(storeId: string, q: string, options?: any): AxiosPromise<ComIbmCommerceToolsContractBeansDisplayCustomizationTCDataBeanIBMStoreDetails> {
            return localVarFp.storeStoreIdTermConditionGet(storeId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds a term condition by its ID.
         * @param {string} storeId The store identifier.
         * @param {string} termConditionId The term condition ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdTermConditionTermConditionIdGet(storeId: string, termConditionId: string, options?: any): AxiosPromise<ComIbmCommerceContractBeansExtendedTermConditionDataBeanIBMStoreDetails> {
            return localVarFp.storeStoreIdTermConditionTermConditionIdGet(storeId, termConditionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermConditionApi - object-oriented interface
 * @export
 * @class TermConditionApi
 * @extends {BaseAPI}
 */
export class TermConditionApi extends BaseAPI {
    /**
     * 
     * @summary Finds the display customization TC of the account associated with the current user.
     * @param {string} storeId The store identifier.
     * @param {string} q The query name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermConditionApi
     */
    public storeStoreIdTermConditionGet(storeId: string, q: string, options?: any) {
        return TermConditionApiFp(this.configuration).storeStoreIdTermConditionGet(storeId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds a term condition by its ID.
     * @param {string} storeId The store identifier.
     * @param {string} termConditionId The term condition ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermConditionApi
     */
    public storeStoreIdTermConditionTermConditionIdGet(storeId: string, termConditionId: string, options?: any) {
        return TermConditionApiFp(this.configuration).storeStoreIdTermConditionTermConditionIdGet(storeId, termConditionId, options).then((request) => request(this.axios, this.basePath));
    }
}
